import React, { useState } from 'react';
import $i18n from '../../../../i18n';
// import { useAppData } from 'ice';
// import Requests from '@/services/blob';
import { Form, Checkbox, Modal } from '@b-design/fusion';
import './index.less';
import { Document, pdfjs, Page } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PrivacyPolicy: React.FC = () => {
  //pdf地址
  // const [termsSite, setTermsSite] = useState('');
  // const [privacySite, setPrivacySite] = useState('');
  // const [isModalVisible, setIsModalVisible] = useState(false);
  // const [isModalVisible2, setIsModalVisible2] = useState(false);

  // const showModal = () => {
  //   setIsModalVisible(true);
  //   Requests.get('/rest/intercnn/tenant/global/config/policy', {
  //     configType: 'POLICY',
  //     urlType: 'policyUrl',
  //   }).then((res) => {
  //     let blob = res;
  //     let reader = new FileReader();
  //     reader.readAsDataURL(blob); // 转换为base64，可以直接放入a标签href
  //     reader.addEventListener('load', function () {
  //       let base64: any = reader.result;
  //       setPrivacySite(base64);
  //     });
  //   });
  // };
  // const handleOk = () => {
  //   setIsModalVisible(false);
  // };
  // const showModal2 = async () => {
  //   Requests.get('/rest/intercnn/tenant/global/config/policy', {
  //     configType: 'POLICY',
  //     urlType: 'termsUrl',
  //   }).then((res) => {
  //     new Promise((resolve, reject) => {
  //       let blob = new Blob([res], { type: 'application/pdf;charset=utf-8' });

  //       const reader = new FileReader();
  //       reader.readAsDataURL(blob);
  //       reader.addEventListener('load', function () {
  //         let base64: any = reader.result;
  //         setTermsSite(base64);
  //       });
  //     });
  //   });
  //   setIsModalVisible2(true);
  // };
  // const handleOk2 = () => {
  //   setIsModalVisible(false);
  // };

  // const handleClose = () => {
  //   setIsModalVisible(false);
  // };
  // const handleClose2 = () => {
  //   setIsModalVisible2(false);
  // };
  // //pdf预览功能
  // const [numPages, setNumPages] = useState(null);

  // function onDocumentLoadSuccess({ numPages }) {
  //   setNumPages(numPages);
  // }
  // //appData
  // const appData = useAppData();
  // const { termsUrl: productTerms, policyUrl: privacyPolicy } = appData?.policyConfig || {};
  // const privacyPolicy = window.__SUPERAPP_CONFIG__?.privacyPolicy || appData?.policyConfig?.policyUrl;
  // const productTerms = window.__SUPERAPP_CONFIG__?.productTerms || appData?.policyConfig?.termsUrl;
  const { privacyPolicy, productTerms } = window.__SUPERAPP_CONFIG__ || {};

  return (
    <>
      {(productTerms || privacyPolicy) && (
        <Form.Item
          style={{ marginBottom: '0px' }}
          name="check1"
          label=""
          required
          requiredMessage={$i18n.get({
            id: 'aopf.pages.login.registerForm.agreement.required',
            dm: '请勾选协议',
          })}
          valueName="checked"
          validator={(_, value) => {
            return new Promise<void>((resolve, reject) => {
              if (!value) {
                return reject(
                  $i18n.get({
                    id: 'aopf.pages.login.registerForm.agreement.required',
                    dm: '请勾选协议',
                  }),
                );
              } else {
                resolve();
              }
            });
          }}
        >
          <Checkbox data-size="small" value="agree"></Checkbox>
          <span style={{ fontSize: '12px', letterSpacing: '0.4px', marginLeft: '8px' }}>
            {$i18n.get({
              id: 'aopf.pages.login.register.agreement.describeA',
              dm: '阅读并接受',
            })}
          </span>
          {productTerms && (
            // <span className="terms-text" onClick={showModal2}>
            <span className="terms-text" onClick={()=> window.open(productTerms)}>
              《{$i18n.get({
                id: 'aopf.pages.login.register.agreement.describeB',
                dm: '服务条款',
              })}》
            </span>
          )}

          {/* {productTerms && privacyPolicy && (
            <span
              style={{
                fontSize: '12px',
                letterSpacing: '0.4px',
              }}
            >
              {$i18n.get({
                id: 'aopf.pages.login.register.agreement.describeC',
                dm: '和',
              })}
            </span>
          )} */}
          {privacyPolicy && (
            // <span className="terms-text" onClick={showModal}>
            <span className="terms-text" onClick={()=> window.open(privacyPolicy)}>
              《{$i18n.get({
                id: 'aopf.pages.login.register.agreement.describeD',
                dm: '隐私协议',
              })}》
            </span>
          )}
        </Form.Item>
      )}

      {/* <Modal
        v2
        title={$i18n.get({
          id: 'aopf.pages.login.pricacyPolicy.dialog.privacyTitle',
          dm: '隐私协议',
        })}
        visible={isModalVisible}
        onOk={handleOk}
        footer={false}
        onClose={handleClose}
        width={1000}
        height={800}
      >
        <div>
          <Document file={privacySite} onLoadSuccess={onDocumentLoadSuccess}>
            {Array.from(new Array(numPages), (el, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                renderAnnotationLayer={false}
                renderTextLayer={false}
                width={930}
              />
            ))}
          </Document>
        </div>
      </Modal> */}
      {/* <Modal
        v2
        title={$i18n.get({
          id: 'aopf.pages.login.pricacyPolicy.dialog.termsTitle',
          dm: '服务条款',
        })}
        visible={isModalVisible2}
        onOk={handleOk2}
        footer={false}
        onClose={handleClose2}
        width={1000}
        height={800}
      >
        <div>
          <Document file={termsSite} onLoadSuccess={onDocumentLoadSuccess}>
            {Array.from(new Array(numPages), (el, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                renderAnnotationLayer={false}
                renderTextLayer={false}
                width={930}
              />
            ))}
          </Document>
        </div>
      </Modal> */}
    </>
  );
};
export default PrivacyPolicy;
